import React, { useEffect, useRef, useState, } from 'react'
import HtmlParser from 'react-html-parser';
import useAuth from '../../auth/useAuth';

import {
    setSeparatorsNumbersNew, settings, styles, setDateTimeFormatGlobal, axios, getError, isUndNullEmpNew, getResponse, getLanguageObj, sendMessageCloseCurrentWindow,
    LoadingSection, awaitDelay, getBadgesClassName
} from '../../helpers/UtilsHelper';
import { setRateVariationsGraph } from '../../helpers/rates/ratesHelper';
import Menu from '../main/Menu';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const currentMethod = 'Home - function';

const { app, icons, images, labels, react, timers } = settings;
const { urls, methods } = app?.backend;
const { tempusDominus } = react;

export default function Home({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    let dataObj = {}
    let headers = {};
    const areaChartId = 'areaChart';
    const auth = useAuth();
    const [items, setItems] = useState([
        { picture: '', title: '---', price: 0.00, priceOtherCurrency: 0.00, register: new Date()?.toISOString() },
        { picture: '', title: '---', price: 0.00, priceOtherCurrency: 0.00, register: new Date()?.toISOString() },
        { picture: '', title: '---', price: 0.00, priceOtherCurrency: 0.00, register: new Date()?.toISOString() },
        { picture: '', title: '---', price: 0.00, priceOtherCurrency: 0.00, register: new Date()?.toISOString() },
    ]);
    const [rates, setRates] = useState([]);
    const [userLast, setUserLast] = useState({});
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: true,
        itemQuantity: true,
        rateQuantity: true,
        accountQuantity: true,
        undefinedQuantity: true,
        rateGraphic: true,
        latestPost: true
    });
    const [usersQuantity, setUsersQuantity] = useState(0);
    const [itemsQuantity, setItemsQuantity] = useState(0);

    // const userRoleSession = RoleSessionClass?.getClass(auth?.account?.role);
    const isMount = useRef(true);
    const formatDateTime = {
        date: languageObj?.id === 'en' ? tempusDominus?.formatDatemdy : tempusDominus?.formatDatedmy,
        time: languageObj?.id === 'en' ? 24 : 12,
    };
    //#endregion variables

    //#region methods
    const getData = async ({
        subMethod = ''
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variable
            //#endregion variables

            setProcess(prev => ({ ...prev, itemQuantity: true, rateQuantity: true, accountQuantity: true, undefinedQuantity: true, rateGraphic: true, latestPost: true }));

            if (auth.isLoged()) {
                response = setDefaultValuesControls({
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;

                //#region get data (home)
                headers = {
                    authorization: `bearer ${auth?.account?.tokenVzLaML?.token}`,
                };

                dataObj = {
                    conditionals: [],
                    ordersBy: [],
                    accountId: auth?.account?.uid,
                    method: methods?.home?.getData,
                }

                response = await axios?.post(`${urls?.url}${urls?.apiV1}${urls?.home}/`, dataObj, headers, currentMethod);
                response = response?.result || response;

                if (!response?.isSuccess || response?.isWarning) return

                //#endregion get data (home)

                //#region set final data
                setItemsQuantity(response?.result?.items ? response?.result?.items?.length : 0);
                setProcess(prev => ({ ...prev, itemQuantity: false }));
                setRates(response?.result?.rates && response?.result?.rates?.length > 0 ? response?.result?.rates : []);
                setProcess(prev => ({ ...prev, rateQuantity: false }));
                setUsersQuantity(response?.result?.users ? response?.result?.users?.length : 0);
                setProcess(prev => ({ ...prev, accountQuantity: false }));
                setUserLast(response?.result?.users && response?.result?.users?.length > 0 ? response?.result?.users?.[0] : {});
                setProcess(prev => ({ ...prev, undefinedQuantity: false }));

                await awaitDelay({ delayTime: timers?.oneSeconds });

                const items_ = response?.result?.items && response?.result?.items?.length > 0 ? response?.result?.items : [];
                let rates_ = response?.result?.rates && response?.result?.rates?.length > 0 ? response?.result?.rates : [];
                if (!isUndNullEmpNew({ data: rates_, subMethod: currentMethod, })?.result && rates_?.length > 0) {
                    rates_ = rates_.slice(0, 7);
                    rates_.sort((a, b) => a.registerISO < b.registerISO ? -1 : 1);
                }
                //#endregion set final data

                //#region Data graph set
                response = setRateVariationsGraph({
                    grpahId: areaChartId,
                    data: rates_,
                    // languageId: languageObj?.id,
                    languageObj: languageObj,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;
                setProcess(prev => ({ ...prev, rateGraphic: false }));

                await awaitDelay({ delayTime: timers?.oneSeconds });
                //#endregion Data graph set

                setItems(items_?.length > 0 ? items_?.slice(0, 4) : []);
                setProcess(prev => ({ ...prev, latestPost: false }));
            } else {
                setShowData(false);
                setProcess(prev => ({ ...prev, showLoading: false }));
                response = setDefaultValuesControls({
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });

        } finally {
            if (!isMount.current) return;

            setProcess(prev => ({ ...prev, itemQuantity: false, rateQuantity: false, accountQuantity: false, undefinedQuantity: false, rateGraphic: false, latestPost: false }));

            if (!response?.isSuccess || response?.isWarning) {
                setShowData(false);
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDefaultValuesControls = ({
        subMethod = ''
    }) => {
        const currentMethod = 'setDefaultValuesControls';
        let response = getResponse({ type: 0 });
        try {
            const ralesLocal = [
                {
                    register: {
                        seconds: 0,
                    },
                    rate: 0.00,
                },
                {
                    register: {
                        seconds: 0,
                    },
                    rate: 0.00,
                },
                {
                    register: {
                        seconds: 0,
                    },
                    rate: 0.00,
                },
                {
                    register: {
                        seconds: 0,
                    },
                    rate: 0.00,
                },
                {
                    register: {
                        seconds: 0,
                    },
                    rate: 0.00,
                },
                {
                    register: {
                        seconds: 0,
                    },
                    rate: 0.00,
                },
                {
                    register: {
                        seconds: 0,
                    },
                    rate: 0.00,
                },
            ];

            response = setRateVariationsGraph({
                grpahId: areaChartId,
                data: ralesLocal,
                // languageId: languageObj?.id,
                languageObj: languageObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getDescriptionItemLastedPosted = ({
        item = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getDescriptionItemLastedPosted';
        let response = getResponse({ type: 0 });
        try {
            response.result = `${labels?.priceOC?.[languageObj?.id]}: <b>${setSeparatorsNumbersNew({ number: item.priceOtherCurrency, withDecimals: true, subMethod: currentMethod })?.result}</b> - `;
            response.result += `${labels?.registry?.[languageObj?.id]}: ${setDateTimeFormatGlobal({ date: item.register, type: formatDateTime?.date, format: formatDateTime?.time, addTime: false, withSeconds: false, subMethod })?.result}`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setHtmlFormat = ({
        subMethod = ''
    }) => {
        const currentMethod = 'setHtmlFormat';
        let response = getResponse({ type: 0 });
        try {
            response.result = {
                productTitle: {
                    fontSize: '14px'
                },
            };
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            response.result = {
                productTitle: {},
            };
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={'home'} process={'home'} />

            <div className='content-wrapper bg-transparent'>
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-12 col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.home?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-12 col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.home?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <section className='content'>
                    <div className='container-fluid'>
                        {auth.isLoged() ? (
                            <div className='row'>
                                {showData ? (
                                    <div className='col-12'>
                                        {/* Small boxes (Stat box) */}
                                        <div className='row'>

                                            <div className='col-12 col-sm-6 col-lg-3 mb-4'>
                                                <div className='card border-0 shadow-lg login-card' >
                                                    <LoadingSection alt='loadingSection'
                                                        className='overlay dark text-white'
                                                        height={20}
                                                        hidden={!process?.itemQuantity}
                                                        width={20}
                                                        languageId={languageObj?.id}
                                                        subMethod={currentMethod} />
                                                    <div className='card-body p-4 d-flex align-items-center justify-content-between'>
                                                        <div className='d-flex flex-column'>
                                                            <span className='text-uppercase text-muted font-weight-bold small mb-1' style={settings?.html?.labels?.detailMicro}>
                                                                {labels?.items?.[languageObj?.id]}
                                                            </span>
                                                            <h3 className='font-weight-bold text-dark mb-0'>{itemsQuantity}</h3>
                                                        </div>
                                                        <div className='p-3 ml-auto rounded-circle shadow-sm d-flex align-items-center justify-content-center'
                                                            style={{ width: '50px', height: '50px', backgroundColor: 'var(--color-info-50)', color: 'var(--color-info-500)' }}>
                                                            <i className={icons?.tags} style={{ fontSize: '1.5rem' }} />
                                                        </div>
                                                    </div>
                                                    {/* {userRoleSession?.getIsAdminOrMaster() && (
                                                        <div className='card-footer bg-transparent border-top-0 pt-0 px-4 pb-3 text-right'>
                                                            <a className='small text-primary font-weight-bold text-uppercase link-primary-bold' href={urls?.process}>
                                                                {labels?.moreInfo?.[languageObj?.id]} <i className={`${icons?.arrowCircleRight} ml-1`} />
                                                            </a>
                                                        </div>
                                                    )} */}
                                                    <div className='card-footer bg-transparent border-top-0 pt-0 px-4 pb-3 text-right'>
                                                        <a className='small text-primary font-weight-bold text-uppercase link-primary-bold' href={urls?.process}>
                                                            {labels?.moreInfo?.[languageObj?.id]} <i className={`${icons?.arrowCircleRight} ml-1`} />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12 col-sm-6 col-lg-3 mb-4'>
                                                <div className='card border-0 shadow-lg login-card' >
                                                    <LoadingSection alt='loadingSection'
                                                        className='overlay dark text-white'
                                                        height={20}
                                                        hidden={!process?.rateQuantity}
                                                        width={20}
                                                        languageId={languageObj?.id}
                                                        subMethod={currentMethod} />
                                                    <div className='card-body p-4 d-flex align-items-center justify-content-between'>
                                                        <div className='d-flex flex-column'>
                                                            <span className='text-uppercase text-muted font-weight-bold small mb-1' style={settings?.html?.labels?.detailMicro}>
                                                                {labels?.rate?.[languageObj?.id]}
                                                            </span>
                                                            <h3 className='font-weight-bold text-dark mb-0'>{rates.length}</h3>
                                                            <span className='small text-muted mt-1 text-truncate' style={{ maxWidth: '140px' }}>
                                                                {labels?.user?.[languageObj?.id] || 'User'}: <b>{`${userLast?.firstName ? userLast?.firstName : ''} ${userLast?.lastName ? userLast?.lastName : ''}`}</b>
                                                            </span>
                                                        </div>
                                                        <div className='p-3 ml-auto rounded-circle shadow-sm d-flex align-items-center justify-content-center'
                                                            style={{ width: '50px', height: '50px', backgroundColor: 'var(--color-success-50)' }}>
                                                            <img alt='forex' src={images?.icons?.forex} style={{ width: '25px', height: '25px', objectFit: 'contain' }} />
                                                        </div>
                                                    </div>
                                                    {/* {userRoleSession?.getIsAdminOrMaster() && (
                                                        <div className='card-footer bg-transparent border-top-0 pt-0 px-4 pb-3 text-right'>
                                                            <a className='small text-primary font-weight-bold text-uppercase link-primary-bold' href='/rates'>
                                                                {labels?.moreInfo?.[languageObj?.id]} <i className={`${icons?.arrowCircleRight} ml-1`} />
                                                            </a>
                                                        </div>
                                                    )}
                                                     */}
                                                    <div className='card-footer bg-transparent border-top-0 pt-0 px-4 pb-3 text-right'>
                                                        <a className='small text-primary font-weight-bold text-uppercase link-primary-bold' href={urls?.rates}>
                                                            {labels?.moreInfo?.[languageObj?.id]} <i className={`${icons?.arrowCircleRight} ml-1`} />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12 col-sm-6 col-lg-3 mb-4'>
                                                <div className='card border-0 shadow-lg login-card' >
                                                    <LoadingSection alt='loadingSection'
                                                        className='overlay dark text-white'
                                                        height={20}
                                                        hidden={!process?.accountQuantity}
                                                        width={20}
                                                        languageId={languageObj?.id}
                                                        subMethod={currentMethod} />
                                                    <div className='card-body p-4 d-flex align-items-center justify-content-between'>
                                                        <div className='d-flex flex-column'>
                                                            <span className='text-uppercase text-muted font-weight-bold small mb-1' style={settings?.html?.labels?.detailMicro}>
                                                                {labels?.accounts?.[languageObj?.id]}
                                                            </span>
                                                            <h3 className='font-weight-bold text-dark mb-0'>{usersQuantity}</h3>
                                                        </div>
                                                        <div className='p-3 ml-auto rounded-circle shadow-sm d-flex align-items-center justify-content-center'
                                                            style={{ width: '50px', height: '50px', backgroundColor: 'var(--color-warning-50)' }}>
                                                            <img alt='group' src={images?.icons?.group} style={{ width: '25px', height: '25px', objectFit: 'contain' }} />
                                                        </div>
                                                    </div>
                                                    <div className='card-footer bg-transparent border-top-0 pt-0 px-4 pb-3 text-right'>
                                                        <a className='small text-primary font-weight-bold text-uppercase link-primary-bold' href={urls?.accounts}>
                                                            {labels?.moreInfo?.[languageObj?.id]} <i className={`${icons?.arrowCircleRight} ml-1`} />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12 col-sm-6 col-lg-3 mb-4'>
                                                <div className='card border-0 shadow-lg login-card' >
                                                    <LoadingSection alt='loadingSection'
                                                        className='overlay dark text-white'
                                                        height={20}
                                                        hidden={!process?.undefinedQuantity}
                                                        width={20}
                                                        languageId={languageObj?.id}
                                                        subMethod={currentMethod} />
                                                    <div className='card-body p-4 d-flex align-items-center justify-content-between'>
                                                        <div className='d-flex flex-column'>
                                                            <span className='text-uppercase text-muted font-weight-bold small mb-1' style={settings?.html?.labels?.detailMicro}>
                                                                {labels?.undefined || 'Undefined'}
                                                            </span>
                                                            <h3 className='font-weight-bold text-dark mb-0'>0</h3>
                                                        </div>
                                                        <div className='p-3 ml-auto rounded-circle shadow-sm d-flex align-items-center justify-content-center'
                                                            style={{ width: '50px', height: '50px', backgroundColor: 'var(--color-danger-50)', color: 'var(--color-danger-500)' }}>
                                                            <i className={icons?.fasFa?.bell} style={{ fontSize: '1.5rem' }} />
                                                        </div>
                                                    </div>
                                                    <div className='card-footer bg-transparent border-top-0 pt-0 px-4 pb-3 text-right'>
                                                        <a className='small text-primary font-weight-bold text-uppercase link-primary-bold' href={urls?.home}>
                                                            {labels?.moreInfo?.[languageObj?.id]} <i className={`${icons?.arrowCircleRight} ml-1`} />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className='row'>

                                            {/* Left col */}

                                            {/*Last Rates*/}
                                            <section className='col-12 col-lg-7 connectedSortable mb-4'>
                                                <div className='card border-0 shadow-lg login-card' >
                                                    <LoadingSection alt='loadingSection'
                                                        className='overlay dark text-white'
                                                        height={20}
                                                        hidden={!process?.rateGraphic}
                                                        width={20}
                                                        languageId={languageObj?.id}
                                                        subMethod={currentMethod} />
                                                    <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                        <div className='d-flex align-items-center justify-content-between'>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <img alt={labels?.ratesVariations?.[languageObj?.id]}
                                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                                        src={images?.icons?.forex} />
                                                                </div>
                                                                <div className='d-flex flex-column'>
                                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.ratesVariations?.[languageObj?.id]}</h5>
                                                                    <div className='mt-1'>
                                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                                            <i className={`${icons?.fasFa?.chartBar} mr-1`}></i> {labels?.rate?.[languageObj?.id]}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='card-tools'>
                                                                <button type='button'
                                                                    className='btn btn-tool'
                                                                    data-card-widget='collapse'>
                                                                    <i className={icons?.fasFa?.minus} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='card-body px-4 pt-2'>
                                                        <div className='chart'>
                                                            <canvas id={areaChartId} style={styles.graphRates} />
                                                        </div>
                                                    </div>
                                                    {/* {userRoleSession?.getIsAdminOrMaster() && (
                                                        <div className='card-footer bg-transparent border-top-0 pt-0 px-4 pb-4 text-right'>
                                                            <a className='small text-primary font-weight-bold text-uppercase link-primary-bold' href='/rates'>
                                                                {labels?.seeAllRates?.[languageObj?.id]} <i className={`${icons?.arrowCircleRight} ml-1`} />
                                                            </a>
                                                        </div>
                                                    )} */}
                                                    <div className='card-footer bg-transparent border-top-0 pt-0 px-4 pb-4 text-right'>
                                                        <a className='small text-primary font-weight-bold text-uppercase link-primary-bold' href={urls?.rates}>
                                                            {labels?.seeAllRates?.[languageObj?.id]} <i className={`${icons?.arrowCircleRight} ml-1`} />
                                                        </a>
                                                    </div>
                                                </div>
                                            </section>

                                            {/* /.Left col */}

                                            <section className='col-12 col-lg-5 connectedSortable mb-4'>
                                                <div className='card border-0 shadow-lg login-card' >
                                                    <LoadingSection alt='loadingSection'
                                                        className='overlay dark text-white'
                                                        height={20}
                                                        hidden={!process?.latestPost}
                                                        width={20}
                                                        languageId={languageObj?.id}
                                                        subMethod={currentMethod} />
                                                    <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                        <div className='d-flex align-items-center justify-content-between'>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <img alt={labels?.latestPostsCreated?.[languageObj?.id]}
                                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                                        src={images?.icons?.review} />
                                                                </div>
                                                                <div className='d-flex flex-column'>
                                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.latestPostsCreated?.[languageObj?.id]}</h5>
                                                                    <div className='mt-1'>
                                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                                            <i className={`${icons?.tags || 'fas fa-tags'} mr-1`}></i> {labels?.items?.[languageObj?.id]}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='card-tools'>
                                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                                    <i className={icons?.fasFa?.minus} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='card-body p-0'>
                                                        {items?.length > 0 ? (
                                                            <ul className='products-list product-list-in-card pl-2 pr-2'>
                                                                {items?.map((item, index) => (
                                                                    <li key={item?.id || `item-${index}`} id={`item-${index}`} className='item bg-transparent'>
                                                                        <div className='product-img'>
                                                                            <img src={item?.picture || images?.noImage} alt='itemPicture' className='img-size-50 rounded shadow-sm' />
                                                                        </div>
                                                                        <div className='product-info'>
                                                                            <a href={`#item-${index}`} className='product-title text-dark font-weight-bold link-primary-bold' style={setHtmlFormat({ subMethod: `#item-${index}` })?.result.productTitle}>
                                                                                {item?.title || ''}
                                                                                <span className={getBadgesClassName({ type: index, subMethod: `#item-${index}` })?.result}>{setSeparatorsNumbersNew({ number: item?.price, withDecimals: true, subMethod: currentMethod })?.result}</span>
                                                                            </a>
                                                                            <span className='product-description' style={setHtmlFormat({ subMethod: `#item-${index} - product-description` })?.result.productTitle}>
                                                                                {HtmlParser(getDescriptionItemLastedPosted({ item: item, subMethod: `#item-${index} - product-description - get` })?.result)}
                                                                            </span>
                                                                        </div>
                                                                    </li>

                                                                ))}
                                                            </ul>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </div>
                                                    {/* {userRoleSession.getIsAdminOrMaster() && (
                                                        <div className='card-footer bg-transparent border-top-0 pt-0 px-4 pb-4 text-right'>
                                                            <a className='small text-primary font-weight-bold text-uppercase link-primary-bold' href='/process'>
                                                                {labels?.seeAllPosts?.[languageObj?.id]} <i className={`${icons?.arrowCircleRight} ml-1`} />
                                                            </a>
                                                        </div>
                                                    )} */}
                                                    <div className='card-footer bg-transparent border-top-0 pt-0 px-4 pb-4 text-right'>
                                                        <a className='small text-primary font-weight-bold text-uppercase link-primary-bold' href={urls?.process}>
                                                            {labels?.seeAllPosts?.[languageObj?.id]} <i className={`${icons?.arrowCircleRight} ml-1`} />
                                                        </a>
                                                    </div>
                                                </div>
                                            </section>

                                        </div>{/* /.row (main row) */}
                                    </div>
                                ) : (
                                    <div className='col-12'></div>
                                )}
                            </div>
                        ) : (
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='text-center align-items-center justify-content-center'>
                                        <h4 className='display-4'>
                                            {settings?.app?.name}
                                        </h4>
                                    </div>

                                    <div className='text-center'>
                                        <img alt='AppLogo' src={images?.appLogo} style={styles.appLogoHome} />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </section>
            </div>
        </div>
    )
}